module.exports = __webpack_public_path__ + "img/BE0403200393.a0cc1dff.png";